/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteOnboardingRequest
 */
export interface CompleteOnboardingRequest {
    /**
     * Firebase user ID
     * @type {string}
     * @memberof CompleteOnboardingRequest
     */
    uid: string;
    /**
     * Medical license number
     * @type {string}
     * @memberof CompleteOnboardingRequest
     */
    licenseNumber?: string;
    /**
     * Medical specialties
     * @type {Array<string>}
     * @memberof CompleteOnboardingRequest
     */
    specialties?: Array<string>;
    /**
     * Practice ID
     * @type {string}
     * @memberof CompleteOnboardingRequest
     */
    practiceId?: string;
}

/**
 * Check if a given object implements the CompleteOnboardingRequest interface.
 */
export function instanceOfCompleteOnboardingRequest(value: object): value is CompleteOnboardingRequest {
    if (!('uid' in value) || value['uid'] === undefined) return false;
    return true;
}

export function CompleteOnboardingRequestFromJSON(json: any): CompleteOnboardingRequest {
    return CompleteOnboardingRequestFromJSONTyped(json, false);
}

export function CompleteOnboardingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteOnboardingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'uid': json['uid'],
        'licenseNumber': json['licenseNumber'] == null ? undefined : json['licenseNumber'],
        'specialties': json['specialties'] == null ? undefined : json['specialties'],
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
    };
}

export function CompleteOnboardingRequestToJSON(json: any): CompleteOnboardingRequest {
    return CompleteOnboardingRequestToJSONTyped(json, false);
}

export function CompleteOnboardingRequestToJSONTyped(value?: CompleteOnboardingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uid': value['uid'],
        'licenseNumber': value['licenseNumber'],
        'specialties': value['specialties'],
        'practiceId': value['practiceId'],
    };
}

